"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialUnlockTx = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const constants_1 = require("../constants");
const social_1 = require("../signature/social");
const utils_1 = require("../utils");
const socialUnlockTx = (servicer, owner, friends, subkey, fee = constants_1.FEE) => { var friends_1, friends_1_1; return __awaiter(void 0, void 0, void 0, function* () {
    var e_1, _a;
    const isMainnet = owner.startsWith('ckb');
    const ownerLock = (0, ckb_sdk_utils_1.addressToScript)(owner);
    const cotaType = (0, constants_1.getCotaTypeScript)(isMainnet);
    const ownerCotaCells = yield servicer.collector.getCells(ownerLock, cotaType);
    if (!ownerCotaCells || ownerCotaCells.length === 0) {
        throw new Error("Cota cell doesn't exist");
    }
    const ownerCotaCell = ownerCotaCells[0];
    const socialMsg = `${(0, ckb_sdk_utils_1.serializeOutPoint)(ownerCotaCell.outPoint)}${(0, utils_1.u16ToBe)(subkey.algIndex)}${(0, utils_1.remove0x)(subkey.pubkeyHash)}`;
    const inputs = [
        {
            previousOutput: ownerCotaCell.outPoint,
            since: '0x0',
        },
    ];
    let cellDeps = [];
    try {
        for (friends_1 = __asyncValues(friends); friends_1_1 = yield friends_1.next(), !friends_1_1.done;) {
            const friend = friends_1_1.value;
            if (friend.unlockMode != 1 && friend.unlockMode != 2) {
                throw new Error('Social unlock mode error');
            }
            const friendLock = (0, ckb_sdk_utils_1.addressToScript)(friend.address);
            // mainkey
            if (friend.unlockMode == 1) {
                const friendCells = yield servicer.collector.getCells(friendLock);
                if (friendCells == undefined || friendCells.length == 0) {
                    throw new Error('The friend address has no live cells');
                }
                const friendCellDep = {
                    outPoint: friendCells[0].outPoint,
                    depType: 'code',
                };
                cellDeps.push(friendCellDep);
            }
            else {
                const friendCells = yield servicer.collector.getCells(friendLock, cotaType);
                if (!friendCells || friendCells.length === 0) {
                    throw new Error("The friend's cota cell doesn't exist");
                }
                const friendCellDep = {
                    outPoint: friendCells[0].outPoint,
                    depType: 'code',
                };
                cellDeps.push(friendCellDep);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (friends_1_1 && !friends_1_1.done && (_a = friends_1.return)) yield _a.call(friends_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    cellDeps.push((0, constants_1.getJoyIDCellDep)(isMainnet));
    cellDeps.push((0, constants_1.getCotaCellDep)(isMainnet));
    const outputs = [ownerCotaCell.output];
    outputs[0].capacity = `0x${(BigInt(outputs[0].capacity) - fee).toString(16)}`;
    const extSubkeyReq = {
        lockScript: (0, ckb_sdk_utils_1.serializeScript)(ownerLock),
        extAction: 0xf0,
        subkeys: [subkey],
    };
    const { smtRootHash, extensionSmtEntry } = yield servicer.aggregator.generateExtSubkeySmt(extSubkeyReq);
    const cotaCellData = `0x02${smtRootHash}`;
    const outputsData = [cotaCellData];
    const rawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses: [],
    };
    rawTx.witnesses = rawTx.inputs.map((_, i) => i > 0 ? '0x' : { lock: '', inputType: `0xF0${extensionSmtEntry}`, outputType: '0x' });
    const socialUnlockReq = {
        lockScript: (0, ckb_sdk_utils_1.serializeScript)(ownerLock),
        friends,
    };
    const signedTx = yield (0, social_1.signSocialTx)(servicer, socialMsg, socialUnlockReq, rawTx);
    console.info(JSON.stringify(signedTx));
    let cycles = yield servicer.collector.getCkb().rpc.dryRunTransaction(signedTx);
    console.info(`Cycles: ${JSON.stringify(cycles)}`);
    let txHash = yield servicer.collector.getCkb().rpc.sendTransaction(signedTx, 'passthrough');
    console.info(`Social recovery unlock tx has been sent with tx hash ${txHash}`);
    return txHash;
}); };
exports.socialUnlockTx = socialUnlockTx;
